import React, { useState, useCallback, useEffect } from "react";
import {  View, Alert,  Platform, StyleSheet, Button } from "react-native";
import "../config/sty.css"
//import * as Location from "expo-location";
import  { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet'

//instancia que configura el icono apuntador del mapa
const myIcon = new   L.icon({ 
    // iconUrl:require('../assets/c.png'),
    iconUrl:require('../assets/fixdplanet1024.png'),
    iconSize:     [30, 30],
    shadowSize:   [50, 64],
    iconAnchor:   [22, 94],
    shadowAnchor: [4, 62],
    popupAnchor:  [-3, -76]
 })  

 //var coordsNum1 = 0
 //var coordsNum2 = 0
 //var coords 
export default function MapVisor({route}) {

          //alert(route.path  )

    var latString = route.params.lat.substring(0, route.params.lat.length)
    var longString = route.params.long.substring(0, route.params.long.length)
    var latNum = parseFloat(latString)
    var longNum = parseFloat(longString)
//     useEffect(() => {
//         getLocation() 
//         // patCoords1 = route.path.substring(12, 21)
//         // patCoords2 = route.path.substring(22, 32)
//         //debugger
//         // coordsNum1 = parseFloat(patCoords1)
//         // coordsNum2 = parseFloat(patCoords2)
//         // setCoordsNum1(parseFloat(patCoords1))
//         // setCoordsNum2(parseFloat(patCoords2))
//         //coords = [coordsNum1, coordsNum2]
//         //numericCords()
//         alert(route.path + ' patCoords1 '+  patCoords1 +' patCoords2 '+ patCoords2 )
//   }, []);
//     const [location, setLocation] = useState(null);
    // const [coordsNum1,setCoordsNum1] = useState(0);
    // const [coordsNum2, setCoordsNum2] = useState(0);

  //  dateContentChat.substring(0, 10).replace('/', '').replace('/', '')
//const coords = [18.8247583, -99.1944086]
 // /Map?coords=18.82704520,-99.191157
//  const numericCords = () => {
//      coordsNum1 = parseFloat(patCoords1)
//      coordsNum2 = parseFloat(patCoords2)
//      coords = [coordsNum1, coordsNum2]
// }


 

//   //---------------------------------------------
//   //Función que consigue la ubicación 
//   //---------------------------------------------
//   const getLocation = async () => {
//     try {
//        //debugger
//       let { status } = await Location.requestForegroundPermissionsAsync();
//       if (status !== 'granted') {
//         alert('acceso a la ubicación fue negado')
//         return;
//       }

//       let locationsss = await Location.getCurrentPositionAsync({});
//       setLocation(locationsss);
//       console.log(' location latitud ->', location.longitude)
//      // var mapa1 = { latitude: location.coords.latitude, longitude: location.coords.longitude, mapType:'transit' }

//     } catch (error) {
//       console.log(error);
//     }
//   };
 // var mapa1 = { latitude: location.coords.latitude, longitude: location.coords.longitude, mapType:'transit' }
  return (
    <>
    
    <View style={styles.imagePhoto} >

<MapContainer 
style={{  width:'500px',
          height:'500px'}} 
         // 51.505, -0.09
         
 //center={[19.2901046,-99.2423181]} 
 center={[latNum, longNum]} 
zoom={16}>
  <TileLayer
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  />
  <Marker 
   // position={[19.2901046,-99.2423181]}
    position={[latNum, longNum]}
    icon={myIcon}
  >

    <Popup>
      latitud{} y longitu ubición . <br /> Easily customizable.
    </Popup>
  </Marker>
</MapContainer>
</View>
    </>
  );
}

const styles = StyleSheet.create({
    imagePhoto:{
        flex : 1,
        width:400,
        height:400
    }
  })